<template>

  <div class="uk-width-1-1 area-riservata__filters" :class="type !== 'mobile' ? 'uk-visible@l' : ''">
    <div class="area-riservata__search">
      <input type="textarea" id="order-search" :placeholder="$t('frontend-mtg.area_riservata.ordini.cerca_ordine')" v-model="searchInput" @keypress.enter="search">
      <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 490 490" fill="#000" class="icon" @click="search">
        <path d="M484 455.2 366.2 337.4c29.2-35.6 46.8-81.2 46.8-130.9C413 92.5 320.5 0 206.5 0 92.4 0 0 92.5 0 206.5S92.4 413 206.5 413c49.7 0 95.2-17.5 130.8-46.7L455.1 484c8 8 20.9 8 28.9 0 8-7.9 8-20.9 0-28.8zm-277.5-83.3C115.2 371.9 41 297.7 41 206.5S115.2 41 206.5 41C297.7 41 372 115.3 372 206.5s-74.3 165.4-165.5 165.4z"></path>
      </svg>
    </div>

    <div class="uk-hidden@desktop">
      <div class="area-riservata__filters--main-title">
        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 490 490" fill="#000" class="icon"><path d="M484 455.2 366.2 337.4c29.2-35.6 46.8-81.2 46.8-130.9C413 92.5 320.5 0 206.5 0 92.4 0 0 92.5 0 206.5S92.4 413 206.5 413c49.7 0 95.2-17.5 130.8-46.7L455.1 484c8 8 20.9 8 28.9 0 8-7.9 8-20.9 0-28.8zm-277.5-83.3C115.2 371.9 41 297.7 41 206.5S115.2 41 206.5 41C297.7 41 372 115.3 372 206.5s-74.3 165.4-165.5 165.4z"></path></svg>
        {{ $t('frontend-mtg.area_riservata.ordini.ordina_per') }}
      </div>
<!--      <form class="uk-form">-->
<!--        <select class="uk-select" id="form-stacked-select">-->
<!--          <option>Data conferma</option>-->
<!--          <option>Anno</option>-->
<!--          <option>N° ordine</option>-->
<!--          <option>Vs. riferimento</option>-->
<!--          <option>Stato avanzamento</option>-->
<!--        </select>-->
<!--      </form>-->
    </div>

    <div class="area-riservata__filters--main-title">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 18.6 18.6" style="enable-background:new 0 0 18.6 18.6;" xml:space="preserve" class="">
        <path id="Shape" class="st0" style="fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;" d="M3.5,10.7V1 M3.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M3.5,10.7c-0.8,0-1.5,0.7-1.5,1.5  s0.7,1.5,1.5,1.5 M3.5,17.5v-3.7 M15.5,10.7V1 M15.5,10.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M15.5,10.7  c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5 M15.5,17.5v-3.7 M9.5,4.7V1 M9.5,4.7c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5 M9.5,4.7  C8.7,4.7,8,5.4,8,6.2s0.7,1.5,1.5,1.5 M9.5,17.5V7.7"></path>
      </svg>
      {{ $t('frontend-mtg.area_riservata.ordini.filtra_per') }}
    </div>
    <div v-if="hasFilters" class="filters__nav-cta">
      <a :href="pageUrl" :title="$t('frontend-mtg.area_riservata.ordini.resetta_filtri')" class="filters__nav-cta toggle">{{ $t('frontend-mtg.area_riservata.ordini.resetta_filtri') }}</a>
    </div>

    <ul uk-accordion class="accordion uk-accordion">

      <li class="uk-position-relative uk-open">
        <a href="#" class="uk-accordion-title area-riservata__filters--title">{{ $t('frontend-mtg.area_riservata.ordini.year') }}</a>
        <div class="uk-accordion-content">
          <form class="uk-form">
            <ul uk-nav="" class="filters__nav uk-nav">

              <li v-for="filterYear in filterYears">
                <label class="checkbox__label">
                  <input type="checkbox" name="order_year" class="uk-checkbox" :value="filterYear" v-model="selectedYear" @change="setFilter('order_year')">
                  <span>{{ filterYear }}</span>
                </label>
              </li>

            </ul>
          </form>

          <!-- TODO: Gestire il mostra di piú, se necessario  -->
          <!-- <div class="filters__nav-cta">-->
          <!--   <a title="Mostra di più" class="filters__nav-cta toggle" uk-toggle="target:.toggle">{{ $t('frontend-mtg.area_riservata.ordini.mostra_piu') }}</a>-->
          <!--   <a hidden title="Mostra di meno" class="filters__nav-cta toggle" uk-toggle="target:.toggle">{{ $t('frontend-mtg.area_riservata.ordini.mostra_meno') }}</a>-->
          <!-- </div>-->

        </div>
      </li>

      <!-- Code -->
      <li class="uk-position-relative uk-open">
        <a href="#" class="uk-accordion-title area-riservata__filters--title">{{ $t('frontend-mtg.area_riservata.ordini.number') }}</a>
        <div class="uk-accordion-content">
          <form class="uk-form">
            <select class="uk-select" id="form-stacked-select" v-model="selectedCode" @change="setFilter('code')">
              <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select_filter') }}</option>
              <option v-for="filterCode in filterCodes" :value="filterCode">{{ filterCode }}</option>
            </select>
          </form>
        </div>
      </li>

      <!-- Code reference -->
<!--      <li class="uk-position-relative uk-open">-->
<!--        <a href="#" class="uk-accordion-title area-riservata__filters&#45;&#45;title">{{ $t('frontend-mtg.area_riservata.ordini.reference') }}</a>-->
<!--        <div class="uk-accordion-content">-->
<!--          <form class="uk-form">-->
<!--            <select class="uk-select" id="form-stacked-select" v-model="selectedReference" @change="setFilter('code_reference')">-->
<!--              <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select_filter') }}</option>-->
<!--              <option v-for="filterReference in filterReferences" :value="filterReference">{{ filterReference }}</option>-->
<!--            </select>-->
<!--          </form>-->
<!--        </div>-->
<!--      </li>-->

      <!-- Processed -->
      <li class="uk-position-relative uk-open">
        <a href="#" class="uk-accordion-title area-riservata__filters--title">{{ $t('frontend-mtg.area_riservata.ordini.progress') }}</a>
        <div class="uk-accordion-content">
          <form class="uk-form">
            <select class="uk-select" id="form-stacked-select" v-model="selectedProcessed" @change="setFilter('process_status')">
              <option :value="null">- {{ $t('frontend-mtg.area_riservata.ordini.select_filter') }}</option>
              <option value="1">{{ $t('frontend-mtg.area_riservata.ordini.non_evaso') }}</option>
              <option value="2">{{ $t('frontend-mtg.area_riservata.ordini.parzialmente_evaso') }}</option>
              <option value="3">{{ $t('frontend-mtg.area_riservata.ordini.evaso') }}</option>
            </select>
          </form>
        </div>
      </li>

    </ul>
  </div>


</template>

<script>
export default {
  props: {
    filtersList: {
      type: [Array, Object],
      required: true,
    },
    pageUrl: {
      type: String,
      required: true,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      count: 0,
      searchInput: null,
      selectedProcessed: null,
      selectedYear: [],
      selectedCode: null,
      selectedReference: null,
      filterYears: null,
      filterCodes: null,
      filterReferences: null,
      filterProcessed: null,
    }
  },
  mounted() {
    this.filterCodes = this.filtersList['code']
    this.filterYears = this.filtersList['order_year']
    this.filterReferences = this.filtersList['code_reference']
  },
  computed: {
    filters(){
      return this.$store.state.grid.filters;
    },
    hasFilters(){
      return Object.keys(this.$store.state.grid.filters).length > 0;
    },
  },
  methods: {
    search() {
      this.$store.commit('grid/addFilter', {column: 'code', value: this.searchInput});
    },
    setFilter(type) {
      let column = null;
      let value = null;
      switch (type) {
        case 'code_reference':
          column = type
          value = this.selectedReference
          break;
        case 'code':
          column = type
          value = this.selectedCode
          break;
        case 'order_year':
          column = type
          value = this.selectedYear
          break;
        case 'process_status':
          column = type
          value = this.selectedProcessed
          break;
        default:
          return;
      }
      this.removeFilter(type)
      this.$store.commit('grid/addFilter', {
        column: type,
        value: value
      });
    },
    removeFilter(type){
      this.$store.commit('grid/removeFilter', {
        column: type,
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrdersListFilters.vue